module.exports = __webpack_public_path__ + "static/media/Calibre-Medium.88178c3f.ttf";